import get from './get';

export default video => {
  if (!video) {
    return video;
  }
  const result = { ...video.image };
  const mobile = get(video, ['alternatives', 'Mobile', 'image']);
  if (get(mobile, ['sizes', 'length'])) {
    result.alternatives = {
      Mobile: mobile,
    };
  }
  return result;
};
